import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { createAndUpdateDairiesServer, getDairiesServer } from "../../../apis/DatesForDairiesApi";
import { useNavigate, useParams } from "react-router-dom";
import { datesForDairiesSchema } from "../../../Validations/datesForDairiesValidations";

export default function AddDatesDairies() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [addDairiesInitial, setAddDairiesInitial] = useState({
    title: "",
    description: "",
    category: "",
    info: "",
    startDate:"",
    endDate:""
  });
  const { id } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
        editDairies();
    }
  }, [id]);
  const editDairies = async () => {
    setEditLoader(true);
    try {
      const res = await getDairiesServer(id);
      let result = res.result;
      console.log({RESU1234567:result})
      if (result) {
        setAddDairiesInitial({
          title: res.result.title,
          description: res.result.description,
          category: res.result.category,
          info: res.result.info,
          startDate: formatDateTime(result.startDate),
          endDate: formatDateTime(result.endDate),
        });
        setEditLoader(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
  
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }
  const formik = useFormik({
    initialValues: addDairiesInitial,
    enableReinitialize: true,
    validationSchema: datesForDairiesSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        let res;
        res = id
          ? await createAndUpdateDairiesServer(id, { ...values, id })
          : await createAndUpdateDairiesServer(id, values);

        setLoading(false);
        formik.resetForm();
        navigate("/dairies");
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/dairies");
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    let year = now.getFullYear();
    let month = String(now.getMonth() + 1).padStart(2, "0");
    let day = String(now.getDate()).padStart(2, "0");
    let hours = now.getHours();
    let minutes = now.getMinutes();

    minutes += 1; // Add 1 minute to prevent selecting the current time

    // Adjust hour if minutes exceed 59
    if (minutes >= 60) {
      minutes = 0;
      hours += 1;
    }

    // Adjust day if hours exceed 23 (midnight roll-over)
    if (hours >= 24) {
      hours = 0;
      const nextDay = new Date(now);
      nextDay.setDate(now.getDate() + 1);
      year = nextDay.getFullYear();
      month = String(nextDay.getMonth() + 1).padStart(2, "0");
      day = String(nextDay.getDate()).padStart(2, "0");
    }

    hours = String(hours).padStart(2, "0");
    minutes = String(minutes).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Title <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="title"
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.title && formik.touched.title && (
                      <span className="text-danger">
                        {formik.errors.title}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.description &&
                      formik.touched.description && (
                        <span className="text-danger">
                          {formik.errors.description}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Category <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="Text"
                      name="category"
                      value={formik.values.category}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.category &&
                      formik.touched.category && (
                        <span className="text-danger">
                          {formik.errors.category}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Information <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="Text"
                      name="info"
                      value={formik.values.info}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.info &&
                      formik.touched.info && (
                        <span className="text-danger">
                          {formik.errors.info}
                        </span>
                      )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Start Date
                    <span className="text-danger">*</span>
                    </label>
                    <input
                      className={`form-control ${
                        formik.touched.startDate && formik.errors.startDate
                          ? "is-invalid"
                          : ""
                      }`}
                      type="datetime-local"
                      name="startDate"
                      value={formik.values.startDate}
                      min={getCurrentDateTime()}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />

                    {formik.touched.startDate && formik.errors.startDate && (
                      <div className="text-danger">
                        {formik.errors.startDate}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">End Date
                    <span className="text-danger">*</span>
                    </label>
                    <input
                      className={`form-control ${
                        formik.touched.endDate && formik.errors.endDate
                          ? "is-invalid"
                          : ""
                      }`}
                      type="datetime-local"
                      name="endDate"
                      value={formik.values.endDate}
                      min={formik.values.startDate || getCurrentDateTime()}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.endDate && formik.errors.endDate && (
                      <div className="text-danger">{formik.errors.endDate}</div>
                    )}
                  </div>

                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
